export function main (_p5) {
  let p5
  p5 = _p5

  const numP = 100 // num of Particles
  let p = []
  const numG = 2 // number of Games
  let g = []
  // const conceptColor = p5.color(255, 56, 39)
  // const conceptColor = p5.color(231, 109, 115)
  const conceptColor = p5.color(255)
  const anotherColor = p5.color(0)

  p5.setup = _ => {
    // 親要素の画面幅を取得
    p5.frameRate(30)
    const parentDiv = document.getElementById('home-p5-canvas')
    const parentWidth = parentDiv.offsetWidth
    const parentHeight = parentDiv.offsetHeight
    const canvas = p5.createCanvas(parentWidth, parentHeight)
    canvas.parent('home-p5-canvas')
    for (let i = 0; i < numP; i++) {
      p[i] = new Particle()
    }
    for (let i = 0; i < numG; i++) {
      g[i] = new Game(i)
    }
    p5.mouseX = p5.width / 2
    p5.mouseY = p5.height / 2
  }

  p5.windowResized = () => {
    // p5.clear()
    // p5.setup()
    const parentDiv = document.getElementById('home-container')
    const parentWidth = parentDiv.offsetWidth
    const parentHeight = parentDiv.offsetHeight
    p5.resizeCanvas(parentWidth, parentHeight)
  }

  p5.draw = () => {
    p5.clear()
    p5.noStroke()
    for (let i = 0; i < g.length; i++) {
      g[i].update()
      g[i].display()
    }
    for (let i = 0; i < p.length; i++) {
      p[i].update()
    }
  }

  class Particle {
    constructor () {
      this.position = p5.createVector(
        p5.random(p5.width),
        p5.random(p5.height)
      )
      this.velocity = p5.createVector()
      this.acceleration = p5.createVector()
      this.topspeed = 4
    }
    update () {
      this.checkDist()
      this.target = g[this.nearestIndex].position.copy()
      // this.acceleration = p5.Vector.sub(this.target, this.position) // これはエラーが出るため、下に2つに分けて書いた。
      this.acceleration.x = this.target.x - this.position.x
      this.acceleration.y = this.target.y - this.position.y

      // this.acceleration.setMag((1 / p5.width) * 40) // default 0.04 p5.widthが小さくなればなるほど求心力が強くなるように
      this.acceleration.setMag(p5.map(1 / p5.width, 0, 1, 0.08, 0.03))
      this.velocity.add(this.acceleration)
      this.velocity.limit(this.topspeed)
      this.position.add(this.velocity)
      this.display()
    }
    display () {
      p5.noStroke()
      if (this.nearestIndex === 0) {
        p5.fill(anotherColor)
      } else {
        p5.fill(conceptColor)
      }
      p5.ellipse(this.position.x, this.position.y, 3)
    }
    checkDist () {
      this.nearestDistance = Infinity
      for (let i = 0; i < numG; i++) {
        this.d = this.position.dist(g[i].position)
        this.nearestDistance =
          this.d <= this.nearestDistance ? this.d : this.nearestDistance
        if (this.nearestDistance === this.d) {
          this.nearestIndex = i
        }
      }
    }
  }

  class Game {
    constructor (index) {
      this.position = p5.createVector(
        p5.random(p5.width),
        p5.random(p5.height)
      )
      this.xoff = p5.random(1000)
      this.yoff = p5.random(1000)
      this.xstep = p5.random(0.003, 0.005)
      this.ystep = p5.random(0.002, 0.003)
      this.index = index

      this.lineLength = 3
    }
    update () {
      if (this.index === 0) {
        this.position = p5.createVector(p5.mouseX, p5.mouseY)
      } else {
        const x = p5.lerp(0, p5.width, p5.noise(this.xoff))
        const y = p5.lerp(
          p5.height * 0.2,
          p5.height * 0.8,
          p5.noise(this.yoff)
        )
        this.position = p5.createVector(x, y)
        this.xoff += this.xstep
        this.yoff += this.ystep
      }
    }
    display () {
      if (this.index === 0) {
        p5.stroke(anotherColor)
      } else {
        p5.stroke(conceptColor)
      }
      p5.line(
        this.position.x - this.lineLength,
        this.position.y - this.lineLength,
        this.position.x + this.lineLength,
        this.position.y + this.lineLength
      )
      p5.noFill()
      p5.ellipse(this.position.x, this.position.y, 20)
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/Particles.js